import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import parse from "html-react-parser";
const HtmlRenderer = ({ html }) => {
    return (_jsx("div", Object.assign({ className: "hemoes-html-content", style: {
            width: "100%",
            overflowWrap: "break-word",
            wordWrap: "break-word",
            maxWidth: "100%",
        } }, { children: parse(html) })));
};
export default HtmlRenderer;
